export default __webpack_public_path__ + "static/media/travel-tic-world.b96b0ce4.png";